export * as local from "./passport/local"
export * as google from "./passport/sso/google"
export * as oidc from "./passport/sso/oidc"
import * as datasourceGoogle from "./passport/datasource/google"

export const datasource = {
  google: datasourceGoogle,
}
export { authError, ssoCallbackUrl } from "./passport/utils"
export { authenticated } from "./authenticated"
export { auditLog } from "./auditLog"
export { tenancy } from "./tenancy"
export { internalApi } from "./internalApi"
export { csrf } from "./csrf"
export { adminOnly } from "./adminOnly"
export { builderOrAdmin } from "./builderOrAdmin"
export { builderOnly } from "./builderOnly"
export { pinoMiddleware as pino } from "../logging/pino/middleware"
export { correlationMiddleware as correlation } from "../logging/correlation/middleware"
export { errorHandling } from "./errorHandling"
export { querystringToBody } from "./querystringToBody"
export { contentSecurityPolicy as csp } from "./contentSecurityPolicy"
export { featureFlagCookie } from "./featureFlagCookie"
export * as joiValidator from "./joi-validator"
export { ip } from "./ip"
